@if (!_loadOption || _loadOption == "HAENGIGE") {
  <h3>{{ "HängigeGbgeschäfte" | translate }}</h3>
}
@if (_loadOption && _loadOption == "ALLE") {
  <h3>{{ "Gbgeschäfte" | translate }}</h3>
}

<cap-list-loader [hasRight]="hasRight" [listLoader]="haengigeLoader">
  <div class="cap-list-loader-content">
    <table [attr.aria-label]="'HängigeGbgeschäfte' | translate" class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th class="noselect" style="cursor: pointer; width: 15%">
      <cap-column-header [columnName]="'Tagebuchnummer'" [sortModel]="tableSortModel.columns.get('tagebuchnummer')"></cap-column-header>
    </th>
    @if (isErweiterungGeschaeftsModulActive) {
      <th class="noselect" style="cursor: pointer; width: 15%">
        <cap-column-header [columnName]="'Status'" [sortModel]="tableSortModel.columns.get('status')"></cap-column-header>
      </th>
    }
    <th class="noselect" style="cursor: pointer; width: 10%">
      <cap-column-header [columnName]="'Eingang'" [sortModel]="tableSortModel.columns.get('eingangTagebuch')"></cap-column-header>
    </th>
    @if (isErweiterungGeschaeftsModulActive) {
      <th class="noselect" style="width: 35%">
        {{ "Anmelder" | translate }}
      </th>
    }
    <th class="noselect" style="width: 25%">
      {{ "Beschreibung" | translate }}
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (geschaeft of haengigeLoader?.items; track geschaeft; let i = $index) {
    <tr>
      <td>
        <cap-kompakt-grundbuchgeschaeft [item]="geschaeft.object"></cap-kompakt-grundbuchgeschaeft>
      </td>
      @if (isErweiterungGeschaeftsModulActive) {
        <td>
          <cap-link
            [enableNavigation]="geschaeft.object.timePoint.isNavigierbar"
            [params]="[geschaeft.object.id.id]"
            [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
            {{ geschaeft.object.status | translate }}
          </cap-link>
        </td>
      }
      <td>
        <cap-link
          [enableNavigation]="isErweiterungGeschaeftsModulActive && geschaeft.object.timePoint.isNavigierbar"
          [params]="[geschaeft.object.id.id]"
          [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
          {{ geschaeft.object.eingangTagebuch | datum }}
        </cap-link>
      </td>
      @if (isErweiterungGeschaeftsModulActive) {
        <td>
          @for (anmelder of geschaeft.anmelder; track anmelder; let i = $index) {
            <cap-link
              [enableNavigation]="showPersonendaten(anmelder.auskunftsperre)"
              [params]="[anmelder.masterId.id, anmelder.version.id.id]"
              [target]="navTargets.NAV_PERSON_STAMM"
              [tooltipParams]="anmelder | tooltipPersonstammPipe">
              <cap-kompakt-stammperson
                [auskunftsperre]="anmelder.auskunftsperre"
                [item]="anmelder.version"
                format="STAMMPERSON_TYP02"></cap-kompakt-stammperson>
            </cap-link>
            @if (i < geschaeft.anmelder.length - 1) {
              <span>,<br /></span>
            }
          }
        </td>
      }
      <td>
        @if (geschaeft.object.mBeschreibung.access !== "NONE") {
          <span>
            <cap-link
              [enableNavigation]="isErweiterungGeschaeftsModulActive && geschaeft.object.timePoint.isNavigierbar"
              [params]="[geschaeft.object.id.id]"
              [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
              {{ geschaeft.object.beschreibung }}
            </cap-link>
          </span>
        }
        @if (geschaeft.object.mBeschreibung.access === "NONE") {
          <span>{{ "gemaessGrundbuch" | translate }}</span>
        }
      </td>
    </tr>
  }
</ng-template>
